import Box from '@mui/material/Box';

import { MAX_WIDTHS } from 'src/utils/constants';

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        p: '1.5rem',

        zIndex: 1,
        maxWidth: MAX_WIDTHS.FOOTER,
      }}
    >
      <img src="/assets/images/powered-by-logo.svg" alt="pdm.IA footer logo" />
    </Box>
  );
}

export default Footer;
